import { render, staticRenderFns } from "./GuideCardAttributesTable.vue?vue&type=template&id=56532ddc&"
import script from "./GuideCardAttributesTable.vue?vue&type=script&lang=js&"
export * from "./GuideCardAttributesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports